/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { GetScanningListByFleetEquipmentsId } from '../../../../store/FLEET/EquipmentInspection/equipmentInspectionSlice';
import useGetEquipmentsList from '../../../../hooks/FLeet/useGetEquipmentsList';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';

const ScanningList = () => {
  const { fleetEquipmentsId } = useParams();

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();

  useEffect(() => {
    if (fleetEquipmentsId) {
      dispatch(GetScanningListByFleetEquipmentsId(fleetEquipmentsId));
    }
  }, [fleetEquipmentsId]);

  const { EquipmentsList } = useGetEquipmentsList();
  const EquipmentData = EquipmentsList?.find(f => f.id === fleetEquipmentsId);

  const { PeriodicallyScanningList, loading } = useAppSelector(state => state.EquipmentInspection);

  const data = PeriodicallyScanningList?.map(item => {
    const totalCount = item.countTrue + item.countFalse;
    const countTruePercentage = Math.ceil((item.countTrue / totalCount) * 100 || 0);
    const countFalsePercentage = Math.floor((item.countFalse / totalCount) * 100 || 0);
    return { ...item, countTruePercentage, countFalsePercentage };
  });

  const columns = [
    { title: t('EquipmentName'), key: 'EquipmentName' },
    { title: t('Driver'), key: 'Driver' },
    { title: t('InspectionDate'), key: 'InspectionDate' },
    { title: t('scanningType'), key: 'scanningType' },
    { title: t('InspectionLevel'), key: 'InspectionLevel' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = data?.map(item => {
    let rowClass;

    let badgeClass;
    switch (item.scanningType) {
      case 'scan':
        badgeClass = 'bg-primary';
        break;
      case 'Handover':
        badgeClass = 'bg-warning text-dark';
        break;
      case 'Takeover':
        badgeClass = 'bg-info';
        break;
      default:
        badgeClass = 'bg-secondary';
    }

    return {
      EquipmentName: i18n.language === 'ar' ? EquipmentData?.name2 : EquipmentData?.name,
      Driver: i18n.language === 'ar' ? item.driverName2 : item.driverName,
      InspectionDate: item.scanningDate,
      scanningType: <span className={`badge ${badgeClass}`}>{item.scanningType}</span>,
      InspectionLevel: (
        <div className='progress'>
          <div className='progress-bar bg-success' style={{ width: `${item.countTruePercentage}%` }}>
            {item.countTruePercentage}%
          </div>
          <div className='progress-bar bg-danger' style={{ width: `${item.countFalsePercentage}%` }}></div>
        </div>
      ),

      action: (
        <button
          type='button'
          className='btn btn-outline-theme btn-sm m-0'
          onClick={() => Navigate(`${item.id}/Edit`)}
          data-toggle='tooltip'
          title='Edit'
        >
          <i className='fas fa-info-circle fa-lg'></i>
        </button>
      ),
      // {t('Edit')}

      rowClass // استخدم rowClass هنا
    };
  });

  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: 'EquipmentInspection',
      link: '/FLEET/EquipmentInspection'
    },
    {
      name: 'PreviousInspections',
      link: null
    }
  ];

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={BcrumbList}
        PageName='PreviousInspections'
        subtitle={i18n.language === 'ar' ? EquipmentData?.name2 : EquipmentData?.name}
      />

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </div>
  );
};

export default ScanningList;
